import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Grid, Box } from '@chakra-ui/react';
import { Text } from '@outdoorly/text';

function SummaryTable(_ref) {
  var data = _ref.data,
    highlightLast = _ref.highlightLast;
  return /*#__PURE__*/React.createElement(Grid, {
    as: "dl",
    gap: "0.8rem",
    gridTemplateColumns: "1fr 1fr"
  }, data.map(function (_ref2, i) {
    var _ref3 = _slicedToArray(_ref2, 2),
      label = _ref3[0],
      value = _ref3[1];
    var extraStyles = highlightLast && i === data.length - 1 ? {
      paddingTop: 2,
      fontWeight: 500
    } : {};
    return /*#__PURE__*/React.createElement(Fragment, {
      key: i
    }, /*#__PURE__*/React.createElement(Box, {
      as: "dt",
      sx: extraStyles
    }, /*#__PURE__*/React.createElement(Text, {
      as: "span"
    }, label)), /*#__PURE__*/React.createElement(Box, {
      as: "dd",
      textAlign: "right",
      sx: extraStyles
    }, /*#__PURE__*/React.createElement(Text, {
      as: "span"
    }, value)));
  }));
}
SummaryTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)).isRequired,
  /*
   * Add some space, and make the final row bold
   */
  highlightLast: PropTypes.bool
};

export { SummaryTable };
